module.exports = "/images/hslp-tier-3.png?824c8a2234b65e5b5e24663763a51879";